import { GeneralTypes } from "@/types";

export const defaultDateFormat = "MM/DD/YYYY";

export const notProvidedFieldPlaceHolder = "Not Provided";

export const yesNoOptions: Array<GeneralTypes.LabelType> = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const adjudicationClaimSources = ["admin", "switch", "pharmacy", "batch-test", "historical", "migrated"];

export const ClaimResponseStatus: GeneralTypes.Dictionary = {
  Paid: "P",
  Rejected: "R",
  Reversal: "A",
};

export const ClaimStatus: GeneralTypes.Dictionary = {
  P: "Paid",
  R: "Rejected",
  A: "Reversal",
};

export const states: Array<GeneralTypes.LabelType> = [
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "American Samoa",
    value: "AS",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "District Of Columbia",
    value: "DC",
  },
  {
    label: "Federated States Of Micronesia",
    value: "FM",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Guam",
    value: "GU",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Marshall Islands",
    value: "MH",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Northern Mariana Islands",
    value: "MP",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Palau",
    value: "PW",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Puerto Rico",
    value: "PR",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  {
    label: "Texas",
    value: "TX",
  },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Virgin Islands",
    value: "VI",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];

export const RelationshipCode: GeneralTypes.Dictionary = {
  "1": "Cardholder/Subscriber",
  "2": "Spouse",
  "3": "Child",
  "4": "Other",
};

export const relationshipCode: Array<GeneralTypes.LabelType> = [
  {
    label: "Cardholder",
    value: "1",
  },
  {
    label: "Spouse",
    value: "2",
  },
  {
    label: "Child",
    value: "3",
  },
  {
    label: "Other",
    value: "4",
  },
];

export const TransactionResponseStatus: GeneralTypes.Dictionary = {
  P: "Paid",
  R: "Rejected",
  A: "Approved",
  B: "Benefit",
  C: "Captured",
  D: "Duplicate of Paid",
  F: "PA Deferred",
  Q: "Duplicate of Capture",
  S: "Duplicate of Approved",
};

export const TransactionCode: GeneralTypes.Dictionary = {
  B1: "Claim",
  B2: "Reversal",
  B3: "Rebill",
  C1: "Controlled Substance Reporting",
  C2: "Controlled Substance Reporting Reversal",
  C3: "Controlled Substance Reporting Rebill",
  D1: "Predetermination of Benefits",
  E1: "Eligibility Verification",
  N1: "Information Reporting",
  N2: "Information Reporting Reversal",
  N3: "Information Reporting Rebill",
  P1: "P.A. Request & Billing",
  P2: "P.A. Reversal",
  P3: "P.A. Inquiry",
  P4: "P.A. Request Only",
  S1: "Service Billing",
  S2: "Service Reversal",
  S3: "Service Rebill",
};

export const GenderCode: GeneralTypes.Dictionary = {
  "1": "Male",
  "2": "Female",
};

export const gender: Array<GeneralTypes.LabelType> = [
  {
    label: "Male",
    value: "M",
  },
  {
    label: "Female",
    value: "F",
  },
  {
    label: "Other",
    value: "U",
  },
];

export const handicapIndicator: Array<GeneralTypes.LabelType> = [
  {
    label: "Yes",
    value: "Y",
  },
  {
    label: "No",
    value: "N",
  },
];

export const includeExcludeOptions: Array<GeneralTypes.LabelType> = [
  {
    value: "included",
    label: "Included",
  },
  {
    value: "excluded",
    label: "Excluded",
  },
];

export const coverageType: Array<GeneralTypes.LabelType> = [
  {
    label: "01 - Single",
    value: "01",
  },
  {
    label: "02 - Employee Plus Spouse",
    value: "02",
  },
  {
    label: "03 - Family",
    value: "03",
  },
  {
    label: "04 - Employee Plus Child",
    value: "04",
  },
  {
    label: "05 - Employee Plus Dependent",
    value: "05",
  },
  {
    label: "06 - Spouse Only",
    value: "06",
  },
  {
    label: "07 - Dependents Only",
    value: "07",
  },
];

export const coverageStatus: Array<GeneralTypes.LabelType> = [
  {
    label: "Primary",
    value: "A",
  },
  {
    label: "Secondary",
    value: "O",
  },
];

export const providerAgreementType: Array<GeneralTypes.LabelType> = [
  {
    label: "Closed Door / Hospital",
    value: "closed_door",
  },
  {
    label: "In-house pharmacy",
    value: "in_house",
  },
  {
    label: "Preferred Pharmacy",
    value: "preferred",
  },
  {
    label: "Long-term care",
    value: "ltc",
  },
  {
    label: "Mail",
    value: "mail",
  },
  {
    label: "Retail",
    value: "retail",
  },
  {
    label: "Specialty",
    value: "specialty",
  },
];

export const hideFromPharmacy: Array<GeneralTypes.LabelType> = [
  {
    label: "Do not hide",
    value: "do_not_hide",
  },
  {
    label: "Exclusion",
    value: "exclusion",
  },
  {
    label: "Mail",
    value: "mail",
  },
  {
    label: "Specialty",
    value: "specialty",
  },
  {
    label: "LTC",
    value: "ltc",
  },
  {
    label: "Closed Door",
    value: "closed_door",
  },
  {
    label: "Non-Retail",
    value: "non_retail",
  },
  {
    label: "ITU",
    value: "itu",
  },
  {
    label: "DoD/VA",
    value: "dod_va",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const lineOfBusiness: Array<GeneralTypes.LabelType> = [
  {
    label: "Cash / Discount",
    value: "cash",
  },
  {
    label: "Commercial",
    value: "commercial",
  },
  {
    label: "Medicaid",
    value: "medicaid",
  },
  {
    label: "Medicare",
    value: "medicare",
  },
];

export const chainCodeOrNcpdp: Array<GeneralTypes.LabelType> = [
  {
    label: "Chain Code",
    value: "C",
  },
  {
    label: "NCPDP",
    value: "N",
  },
];

export const brandGenericMethod: Array<GeneralTypes.LabelType> = [
  {
    label: "Discount Card",
    value: "method_discount_card",
  },
  {
    label: "MONY Code Based",
    value: "method_mony",
  },
  {
    label: "NADAC Based",
    value: "method_nadac",
  },
  {
    label: "JUDI Standard",
    value: "method_standard",
  },
];

export const dmrOptions: Array<GeneralTypes.LabelType> = [
  {
    label: "In-Network DMR",
    value: "2",
  },
  {
    label: "Out-of-Network DMR",
    value: "1",
  },
  {
    label: "Subrogation",
    value: "3",
  },
  {
    label: "Provider Vaccine Reimbursement",
    value: "5",
  },
];

// 1000 (milliseconds) * 60 (seconds) * 60 (minutes) * 2 (hours)
export const userTimeout = 1000 * 60 * 60 * 2;

export const classificationMap: GeneralTypes.Dictionary = {
  br30: "Brand 30",
  br90: "Brand 90",
  gn30: "Generic 30",
  gn90: "Generic 90",
};

// Common plan benefits form values that are repeatedly being checked.
export const commonFormValues = {
  INCLUDED_VALUE: "included",
  EXCLUDED_VALUE: "excluded",
  NO_VALUE: "no",
  YES_VALUE: "yes",
};

export const basisOfReimbursement: GeneralTypes.Dictionary = {
  "00": "00 - Not Specified",
  "01": "01 - Paid as Submitted",
  "02": "02 - Reduced to AWP Pricing",
  "03": "03 - Reduced to AWP Less X% Pricing",
  "04": "04 - Usual & Customary",
  "05": "05 - Paid Lower of Ingredient Cost Plus Fees Versus Usual & Customary",
  "06": "06 - MAC Pricing Ingredient Cost Paid",
  "07": "07 - MAC Pricing Ingredient Cost Reduced to MAC",
  "08": "08 - Contract Pricing",
  "09": "09 - Acquisition Pricing",
  "10": "10 - ASP (Average Sales Price)",
  "11": "11 - AMP (Average Manufacturer Price)",
  "12": "12 - 340B",
  "13": "13 - WAC",
  "14": "14 - Other Payer-Patient Responsibility Amount",
  "15": "15 - Patient Pay Amount",
  "16": "16 - Coupon Payment",
  "17": "17 - Special Payment Reimbursement",
  "18": "18 - Direct Price (DP)",
  "19": "19 - State Fee Schedule (SFS) Reimbursement",
  "20": "20 - National Average Drug Acquisition Cost (NADAC)",
  "21": "21 - State Average Acquisition Cost (AAC)",
  "46": "46 - Maximum Fair Price",
  "": "Not Specified",
};

export const basisOfCost: GeneralTypes.Dictionary = {
  "00": "00 - Default",
  "01": "01 - AWP (Average Wholesale Price)",
  "02": "02 - Local Wholesaler",
  "03": "03 - Direct",
  "04": "04 - EAC (Estimated Acquisition Cost)",
  "05": "05 - Acquisition",
  "06": "06 - MAC (Maximum Allowable Cost)",
  "07": "07 - Usual & Customary",
  "08": "08 - 340B",
  "09": "09 - Other",
  "10": "10 - ASP (Average Sales Price)",
  "11": "11 - AMP (Average Manufacturer Price)",
  "12": "12 - WAC (Wholesale Acquisition Cost)",
  "13": "13 - Special Patient Pricing",
  "14": "14 - Un-reportable quantities",
  "": "Not Specified",
};

export const productServiceIDQualifier: GeneralTypes.Dictionary = {
  "00": "00 - Not Specified",
  "01": "01 - Universal Product Code (UPC)",
  "02": "02 - Health Related Item (HRI)",
  "03": "03 - National Drug Code (NDC)",
  "04": "04 - Health Industry Business Communications Council (HIBCC)",
  "06": "06 - Drug Use Review/ Professional Pharmacy Service (DUR/PPS)",
  "07": "07 - Common Procedure Terminology (CPT4)",
  "08": "08 - Common Procedure Terminology (CPT5)",
  "09": "09 - Health Care Financing Administration Common Procedural Coding System (HCPCS)",
  "10": "10 - Pharmacy Practice Activity Classification (PPAC)",
  "11": "11 - National Pharmaceutical Product Interface Code (NAPPI)",
  "12": "12 - Global Trade Identification Number (GTIN)",
  "15": "15 - First DataBank Formulation ID (GCN)",
  "28": "28 - First DataBank Medication Name ID (FDB Med Name ID)",
  "29": "29 - First DataBank Routed Medication ID (FDB Routed Med ID)",
  "30": "30 - First DataBank Routed Dosage Form ID (FDB Routed Dosage Form Med ID)",
  "31": "31 - First DataBank Medication ID (FDB MedID)",
  "32": "32 - First DataBank Clinical Formulation ID Sequence Number (GCN_SEQ_NO)",
  "33": "33 - First DataBank Ingredient List ID (HICL_SEQ_NO)",
  "34": "34 - Universal Product Number (UPN)",
  "36": "36 - Representative National Drug Code (NDC)",
  "99": "99 - Other",
  "": "Not Specified",
};

export const specialPackagingIndicator: GeneralTypes.Dictionary = {
  "0": "0 - Not Specified",
  "1": "1 - Not Unit Dose",
  "2": "2 - Manufacturer Unit Dose",
  "3": "3 - Pharmacy Unit Dose",
  "4": "4 - Pharmacy Unit Dose Patient Compliance Packaging",
  "5": "5 - Pharmacy Multi-drug Patient Compliance Packaging",
  "6": "6 - Remote Device Unit Dose",
  "7": "7 - Remote Device Multi- drug Compliance",
  "8": "8 - Manufacturer Unit of Use Package (not unit dose)",
  "": "Not Specified",
};

export const compoundCode: GeneralTypes.Dictionary = {
  "0": "0 - Not Specified",
  "1": "1 - Not a Compound",
  "2": "2 - Compound",
  "": "Not Specified",
};

export const origPresProductServiceIDQualifier: GeneralTypes.Dictionary = {
  "00": "00 - Not Specified",
  "01": "01 - Universal Product Code (UPC)",
  "02": "02 - Health Related Item (HRI)",
  "03": "03 - National Drug Code (NDC)",
  "04": "04 - Health Industry Business Communications Council (HIBCC)",
  "06": "06 - Drug Use Review/ Professional Pharmacy Service (DUR/PPS)",
  "07": "07 - Common Procedure Terminology (CPT4)",
  "08": "08 - Common Procedure Terminology (CPT5)",
  "09": "09 - Health Care Financing Administration Common Procedural Coding System (HCPCS)",
  "10": "10 - Pharmacy Practice Activity Classification (PPAC)",
  "11": "11 - National Pharmaceutical Product Interface Code (NAPPI)",
  "12": "12 - Global Trade Identification Number (GTIN)",
  "15": "15 - First DataBank Formulation ID (GCN)",
  "28": "28 - First DataBank Medication Name ID (FDB Med Name ID)",
  "29": "29 - First DataBank Routed Medication ID (FDB Routed Med ID)",
  "30": "30 - First DataBank Routed Dosage Form ID (FDB Routed Dosage Form Med ID)",
  "31": "31 - First DataBank Medication ID (FDB MedID)",
  "32": "32 - First DataBank Clinical Formulation ID Sequence Number (GCN_SEQ_NO)",
  "33": "33 - First DataBank Ingredient List ID (HICL_SEQ_NO)",
  "38": "38 - RxNorm Semantic Clinical Drug (SCD)",
  "39": "39 - RxNorm Semantic Branded Drug (SBD)",
  "40": "40 - RxNorm Generic Package (GPCK)",
  "41": "41 - RxNorm Branded Package (BPCK)",
  "99": "99 - Other",
  "": "Not Specified",
};

export const dawCode: GeneralTypes.Dictionary = {
  "0": "0 - No Product Selection Indicated",
  "1": "1 - Substitution Not Allowed by Prescriber",
  "2": "2 - Substitution Allowed - Patient Requested Product Dispensed",
  "3": "3 - Substitution Allowed - Pharmacist Selected Product Dispensed",
  "4": "4 - Substitution Allowed - Generic Drug Not in Stock",
  "5": "5 - Substitution Allowed - Brand Drug Dispensed as a Generic",
  "6": "6 - Override",
  "7": "7 - Substitution Not Allowed - Brand Drug Mandated by Law",
  "8": "8 - Substitution Allowed - Generic Drug Not Available in Marketplace",
  "9": "9 - Substitution Allowed By Prescriber but Plan Requests Brand",
  "": "Not Specified",
};

export const deliveryType: GeneralTypes.Dictionary = {
  EMAIL: "email",
  SFTP: "sftp",
  S3: "s3",
  FTPS: "ftps",
};

export const reportType: GeneralTypes.Dictionary = {
  DATES: "dates",
  IDS: "ids",
};

export const drugSeparator = "|";

export const prescriberIdentificationType: Array<GeneralTypes.LabelType> = [
  {
    label: "DEA ID",
    value: "dea_id",
  },
  {
    label: "Prescriber NPI",
    value: "prescriber_id",
  },
];

export const agreementChannel: Array<GeneralTypes.LabelType> = [
  {
    label: "Retail",
    value: "R",
  },
  {
    label: "Mail",
    value: "M",
  },
  {
    label: "Specialty",
    value: "S",
  },
];
